__webpack_nonce__ = window.csp_nonce
require('./bootstrap')
import componentRegistry from './components.js'
import { createApp, createVNode, h, render, mergeProps } from 'vue'
import store from './store'

const $ = window.$ = require('jquery')

let app = createApp({
  render: () => { }
})

app.use(store)

let _initialized = false

app.mixin( {
  beforeCreate: function() {
    if (_initialized)
      return

    const apiToken = document.head.querySelector('meta[name="api-token"]')
    this.$store.commit('setApiToken', apiToken ? apiToken.content : null)

    const csrfToken = document.head.querySelector('meta[name="csrf-token"]')
    this.$store.commit('setCsrfToken', csrfToken ? csrfToken.content : null)

    this.$store.dispatch('initialize', window.userData)
    _initialized = true
  },
  // mounted: function() { }
})

app.mount('#app-mount')

const components = componentRegistry.registerComponents(app)

for (const tag in components) {
    const component = components[tag];

    // loop through all attributes of the component's template
    // extract all props that start with : and define correct data type for each
    // apply the props and other standard attributes to the component and render it
    document.querySelectorAll(tag).forEach(elem => {
      const domProps = mergeProps([...elem.attributes])
      let props = {}
      Object.values(domProps).forEach(_attr => {
        const key = _attr.name
        const value = _attr.value

        if (key[0] === ':') {
          const _key = key.slice(1)
          const dataType = determineType(value);
          if (dataType === 'json' || dataType === 'array') {
            props[_key] = JSON.parse(value);
          } else if (dataType === 'boolean') {
            props[_key] = Boolean(value);
          } else if (dataType === 'number') {
            props[_key] = parseFloat(value);
          } else {
            props[_key] = value;
          }
        } else {
          props[key] = value;
        }
        return props;
      }, {});

        const slots = convertChildrenToSlots([...elem.children]);
        mountComponent(app, elem, component, props, slots);

        // move the component's DOM before the mount element
        [...elem.children].forEach(child => elem.parentNode.insertBefore(child, elem));

        // remove the mount element not to clutter the page
        elem.remove();
    });
}

function mountComponent(app, element, component, props, children) {
  let vNode = createVNode(component, props, children)
  vNode.appContext = app._context
  render(vNode, element)
  return vNode.component
}

function convertChildrenToSlots(children) {
  const slots = {};
  children.forEach((child, index) => {
    const slotAttributes = child.getAttributeNames().filter(attr => attr.startsWith('v-slot:'));
    const sortedSlots = slotAttributes.map(attr => attr.replace('v-slot:', ''));
    const slotName = sortedSlots || 'default';
    if (!slots[slotName]) {
      slots[slotName] = () => [];
    }
    slots[slotName] = () => h('div', { innerHTML: child.innerHTML });
  });
  return slots;
}

function determineType(value) {
  try {
      const parsedValue = JSON.parse(value);
      if (Array.isArray(parsedValue))
          return 'array';

      if (typeof parsedValue === 'object' && parsedValue !== null)
          return 'json';

  } catch (e) { } // not json

  if (value === 'true' || value === 'false' || value === true || value === false) {
    return 'boolean';
  }

  if (!isNaN(value)) {
      return 'number';
  }

  return 'string';
}

// logout button
$(function () {
  // framebuster
  if (window.top.location !== window.self.location) {
    window.top.location = window.self.location
  }

  $('#logout-btn').on('click', function (event) {
    event.preventDefault()
    $('#logout-form').trigger('submit')
  })

  $('[data-href]').on('click', function ({ currentTarget }) {
    const url = currentTarget.getAttribute('data-href')
    if (url) {
      // console.log('Navigating to: ', url)
      window.location = url
    }
  })

  function confirmation(e) {
    const message = e.currentTarget.getAttribute('data-confirm') || 'Are you sure?'
    if (!window.confirm(message)) {
      e.preventDefault()
    }
  }

  // Prevents form resubmission
  function validateForm(e) {
    let $el = $(e.currentTarget)

    if ($el.attr('disabled'))
      return false;

    $el.attr('disabled', 'disabled')
    $el.parents('form').trigger('submit')
  }

  $('button[data-confirm], a[data-confirm], input[data-confirm]').on('click', confirmation)
  $('form[data-confirm]').on('submit', confirmation)
  $('form [data-prevent-resubmit]').on('click', validateForm)
})
